// extracted by mini-css-extract-plugin
export default {"react-datepicker__month--selecting-range":"hNVv"};